import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SydButton from '../../../../../commonDesign/Button'
import Icon from '../../../../../atoms/Icon'
import { useAgentPanelContext } from '../AgentPanelContext'

const useStyles = makeStyles(() => ({
  root: {
    border: '1px solid var(--color-ai-300)',
    background: 'linear-gradient(135deg, var(--color-ai-050) 0%, var(--surface-bg-color-d1) 100%)',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: 'var(--color-ai-400)',
      boxShadow: 'var(--shadow-md)'
    }
  },
  titleRow: {
    color: 'var(--color-ai-600)'
  },
  charCount: {
    color: 'var(--color-neutral-400)',
    whiteSpace: 'nowrap'
  },
  description: {
    color: 'var(--color-neutral-600)',
    lineHeight: 1.5
  },
  divider: {
    height: '1px',
    background: 'var(--color-ai-200)',
    margin: '2px 0'
  },
  dismissed: {
    opacity: 0.4,
    pointerEvents: 'none',
    background: 'var(--surface-bg-color-d1)',
    border: '1px solid var(--color-neutral-300)',
    '&:hover': {
      borderColor: 'var(--color-neutral-300)',
      boxShadow: 'var(--shadow-sm)'
    }
  },
  dismissedLabel: {
    color: 'var(--color-neutral-500)',
    textAlign: 'center',
    fontStyle: 'italic'
  }
}))

function ProposedContentCard ({ content, description }) {
  const classes = useStyles()
  const { onApplyJsx, onSaveVersion, versionSaveStatus } = useAgentPanelContext()
  const [dismissed, setDismissed] = useState(false)
  const isSaving = versionSaveStatus === 'saving'

  if (dismissed) {
    return (
      <div className={`${classes.root} ${classes.dismissed} flex flex-col gap-2 radius-lg shadow-sm my-3 p-3`}>
        <div className={`${classes.dismissedLabel} font-size-xs p-1`}>Proposed content dismissed</div>
      </div>
    )
  }

  return (
    <div className={`${classes.root} flex flex-col gap-2 radius-lg shadow-sm my-3 p-3`}>
      <div className='flex items-center justify-between gap-2'>
        <div className={`${classes.titleRow} flex items-center gap-2`}>
          <Icon name='vbsTreeView' customSize='20px' />
          <span className='font-size-sm font-weight-semibold'>Proposed View</span>
        </div>
        <span className={`${classes.charCount} font-size-xs`}>{content.length.toLocaleString()} chars</span>
      </div>
      {description && (
        <div className={`${classes.description} font-size-xs`}>{description}</div>
      )}
      <div className={classes.divider} />
      <div className='flex items-center justify-between gap-2'>
        <SydButton size='xs' variant='outline' onClick={() => setDismissed(true)}>
          Dismiss
        </SydButton>
        <div className='flex gap-2'>
          <SydButton size='xs' variant='outline' onClick={() => navigator.clipboard.writeText(content)}>
            Copy
          </SydButton>
          {onApplyJsx && (
            <SydButton size='xs' variant='ai' onClick={() => onApplyJsx(content)}>
              Apply
            </SydButton>
          )}
          {onSaveVersion && (
            <SydButton
              size='xs'
              variant='ai'
              onClick={() => onSaveVersion(content)}
              processing={isSaving}
              disabled={isSaving}
            >
              {isSaving ? 'Creating...' : 'New Version'}
            </SydButton>
          )}
        </div>
      </div>
    </div>
  )
}

ProposedContentCard.propTypes = {
  content: PropTypes.string.isRequired,
  description: PropTypes.string
}

export default ProposedContentCard
